import { render, staticRenderFns } from "./KeapMarketingNumberTemplateManagerTextBox.vue?vue&type=template&id=487203e6&scoped=true"
import script from "./KeapMarketingNumberTemplateManagerTextBox.vue?vue&type=script&lang=js"
export * from "./KeapMarketingNumberTemplateManagerTextBox.vue?vue&type=script&lang=js"
import style0 from "./KeapMarketingNumberTemplateManagerTextBox.vue?vue&type=style&index=0&id=487203e6&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487203e6",
  null
  
)

export default component.exports